/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/tooltip/tooltip-container.component';
import * as import2 from 'ngx-bootstrap/tooltip/tooltip.config';
const styles_TooltipContainerComponent:any[] = ['.tooltip[_nghost-%COMP%] {\n      display: block;\n    }\n    .bs-tooltip-top[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-bottom[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      left: calc(50% - 2.5px);\n    }\n    .bs-tooltip-left[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%], .bs-tooltip-right[_nghost-%COMP%]   .arrow[_ngcontent-%COMP%] {\n      top: calc(50% - 2.5px);\n    }'];
export const RenderType_TooltipContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 0,
  styles: styles_TooltipContainerComponent,
  data: {}
}
);
export function View_TooltipContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(2,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'tooltip-arrow arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'tooltip-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(null as any),(null as any));
}
function View_TooltipContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'bs-tooltip-container',[[
        'role',
        'tooltip'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        2,
        'show',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),View_TooltipContainerComponent_0,RenderType_TooltipContainerComponent)),
    import0.ɵdid(2121728,(null as any),0,import1.TooltipContainerComponent,[import2.TooltipConfig],(null as any),(null as any))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = (((((((('tooltip in tooltip-' + import0.ɵnov(v,1).placement) + ' ') + 'bs-tooltip-') + import0.ɵnov(v,1).placement) + ' ') + import0.ɵnov(v,1).placement) + ' ') + import0.ɵnov(v,1).containerClass);
    const currVal_1:boolean = !import0.ɵnov(v,1).isBs3;
    ck(v,0,0,currVal_0,currVal_1);
  });
}
export const TooltipContainerComponentNgFactory:import0.ComponentFactory<import1.TooltipContainerComponent> = import0.ɵccf('bs-tooltip-container',import1.TooltipContainerComponent,View_TooltipContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy90bXAvc3dpZnQtYnVpbGQvcHJvZC9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC90b29sdGlwL3Rvb2x0aXAtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLlRvb2x0aXBDb250YWluZXJDb21wb25lbnQuaHRtbCIsIm5nOi8vL3RtcC9zd2lmdC1idWlsZC9wcm9kL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL3Rvb2x0aXAvdG9vbHRpcC1jb250YWluZXIuY29tcG9uZW50LmQudHMuVG9vbHRpcENvbnRhaW5lckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJ0b29sdGlwLWFycm93IGFycm93XCI+PC9kaXY+XG4gICAgPGRpdiBjbGFzcz1cInRvb2x0aXAtaW5uZXJcIj48bmctY29udGVudD48L25nLWNvbnRlbnQ+PC9kaXY+XG4gICAgIiwiPGJzLXRvb2x0aXAtY29udGFpbmVyPjwvYnMtdG9vbHRpcC1jb250YWluZXI+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtNQUNJO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBdUM7TUFDdkM7UUFBQTtRQUFBO01BQUE7SUFBQTtnQkFBMkI7SUFBK0I7Ozs7OztNQ0Y5RDtRQUFBO1FBQUE7TUFBQTtJQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztJQUFBO0tBQUE7Z0JBQUE7OztJQUFBO0lBQUE7SUFBQSxTQUFBLG1CQUFBOzs7In0=



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/tooltip/tooltip-container.component.ngfactory.ts